import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master-account',
  templateUrl: './master-account.component.html',
  styleUrls: ['./master-account.component.css']
})
export class MasterAccountComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
